import {
  createContext,
  FC,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

interface SEOContextType {
  updateSEO: (data: SEOData) => void;
  seoData: SEOData;
}

export interface SEOData {
  title?: string;
  description?: string;
  image?: string;
  article?: boolean;
}

const defaultSEOData: SEOData = {
  title: "AlphaMind - Decentralized Fundraising Platform",
  description:
    "AlphaMind is a decentralized fundraising platform for blockchain projects. Participate in IDOs, build karma, and claim tokens.",
  image: "https://app.alphamind.co/logo.png",
  article: false,
};

const SEOContext = createContext<SEOContextType>({
  updateSEO: () => {},
  seoData: defaultSEOData,
});

export const useSEO = () => useContext(SEOContext);

interface SEOProviderProps {
  children: ReactNode;
}

export const SEOProvider: FC<SEOProviderProps> = ({ children }) => {
  const [seoData, setSEOData] = useState<SEOData>(defaultSEOData);

  const updateSEO = useCallback((data: SEOData) => {
    setSEOData((prevData) => ({
      ...prevData,
      ...data,
    }));
  }, []);

  const value = useMemo(() => ({ updateSEO, seoData }), [seoData, updateSEO]);

  return <SEOContext.Provider value={value}>{children}</SEOContext.Provider>;
};
